<template lang='pug' src='./template/TopOffers.pug'></template>
<style lang='stylus' src='./styles/TopOffers.styl' scoped></style>

<script>
export default {

    filters: {
        truncateTitle(title) {
            if (title.length > 40) {
                return `${title.substring(0, 40)} ...`;
            }
            return title;
        },
    },


    data() {
        return {
           offers: []
        }
    },


    async mounted() {
        this.offers = await this.getTopOffers();
    },

    


    methods: {

        async getTopOffers() {
            const response = await window.axios.get('/api/deals/?topFour=true');

            return response.data.data;
        },

        /**
         * On click: Navigate to deal.
         */
        navigateToDeal(deal) {
            let title = deal.title.replace(/[^a-z0-9_]+/gi, '-').replace(/^-|-$/g, '').toLowerCase();
            this.$router.push(`deal/${deal.id}/${title}`);
        },
    },
};
</script>
